import './styles.scss'
import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { deleteProcessCategory, deleteProcess, updateModalError } from 'redux/smartchat/header/actions'
import ModalWrapper from 'components/ModalWrapper'
import ModalDelete from 'components/ModalDelete'
import CategoriesTypeCard from './CategoriesTypeCard'
import ProcessModal from './ProcessModal'
import CategoryModal from './CategoryModal'
import { Button } from 'components/Form'
import flagEnvDisplay from 'constants/flagEnvDisplay'

// const DISPLAY_PROCCESS = flagEnvDisplay.displayEcommerceAV()
//   ? ['conversational', 'assistant', 'transactional']
//   : ['conversational', 'assistant']

const ProcessesList = () => {
  const { processesList, modalLoading, modalError, header } = useSelector(store => store.smartchatHeader)
  const DISPLAY_PROCCESS = flagEnvDisplay.displayEcommerceAV(header?.company) //@TODO eliminar y dejar el anterior (línea 15) cuando se añada el ecommerce en PRO
    ? ['conversational', 'assistant', 'transactional']
    : ['conversational', 'assistant']
  const dispatch = useDispatch()
  const [searchValue, setSearchValue] = useState('')
  const [processCalledFrom, setProcessCalledFrom] = useState([])
  const [processModal, setProcessModal] = useState({})
  const [categoryModal, setCategoryModal] = useState({})
  const [isOpenProcessCalledFromModal, setIsOpenProcessCalledFromModal] = useState(false)
  const [isOpenProcessNotificationModal, setIsOpenProcessNotificationModal] = useState(false)

  const toggleProcessModal = (modalData = {}) => {
    const { mode = '', processType = '', categoryId = '', processId = '' } = modalData
    if (modalError) dispatch(updateModalError(null))
    setProcessModal(prevState => ({ ...prevState, isOpen: !prevState.isOpen, mode, processType, categoryId, processId }))
  }

  const toggleDeleteProcessModal = (modalData = {}) => {
    const { processId = '' } = modalData
    if (modalError) dispatch(updateModalError(null))
    setProcessModal(prevState => ({ ...prevState, isOpenDelete: !prevState.isOpenDelete, processId }))
  }

  const toggleCategoryModal = (modalData = {}) => {
    const { mode = '', processType = '', categoryId = '' } = modalData
    if (modalError) dispatch(updateModalError(null))
    setCategoryModal(prevState => ({ ...prevState,  isOpen: !prevState.isOpen, mode, processType, categoryId }))
  }

  const toggleDeleteCategoryModal = (modalData = {}) => {
    const { categoryId = '' } = modalData
    if (modalError) dispatch(updateModalError(null))
    setCategoryModal(prevState => ({ ...prevState,  isOpenDelete: !prevState.isOpenDelete, categoryId }))
  }

  const toggleProcessCalledFromModal = (calledFrom) => {
    if (calledFrom && Array.isArray(calledFrom)) {
      setProcessCalledFrom(calledFrom)
    } else {
      setProcessCalledFrom([])
    }
    setIsOpenProcessCalledFromModal(!isOpenProcessCalledFromModal)
  }

  const toggleProcessNotificationModal = () => setIsOpenProcessNotificationModal(!isOpenProcessNotificationModal)

  const processes = searchValue ? processesList.filter(process => process.processName.toLowerCase().includes(searchValue.toLowerCase())) : processesList

  return (
    <div className='process-list animated fadeIn'>
      <div className='process-list__search'>
        <i className='fa fa-search'></i>
        <input type='text' placeholder={I18n.t('dashboard_filter-processes')} value={searchValue} onChange={event => setSearchValue(event.target.value.trimStart())}/>
        {searchValue && (
          <button onClick={() => setSearchValue('')}>
            <i className='fa fa-times'></i>
          </button>
        )}
      </div>
      <div className='process-list__list'>
        {DISPLAY_PROCCESS.map((processType, index) => (
          <CategoriesTypeCard
            key={index}
            processType={processType}
            processes={processes.filter(process => process.processType === processType)}
            toggleCategoryModal={toggleCategoryModal}
            toggleDeleteCategoryModal={toggleDeleteCategoryModal}
            toggleProcessCalledFromModal={toggleProcessCalledFromModal}
            toggleProcessModal={toggleProcessModal}
            toggleDeleteProcessModal={toggleDeleteProcessModal}
            toggleProcessNotificationModal={toggleProcessNotificationModal}
          />
        ))}
      </div>

      {processModal.isOpen && (
        <ProcessModal
          isOpen={processModal.isOpen}
          toggle={toggleProcessModal}
          mode={processModal.mode}
          processType={processModal.processType}
          categoryId={processModal.categoryId}
          processId={processModal.processId}
        />
      )}

      {processModal.isOpenDelete && (
        <ModalDelete
          isOpen={processModal.isOpenDelete}
          toggle={toggleDeleteProcessModal}
          header={I18n.t('dashboard_delete-process')}
          text1={I18n.t('dashboard_sure-want-delete-process')}
          text2={I18n.t('dashboard_action-cannot-reversed')}
          event={() => dispatch(deleteProcess({ processId: processModal.processId, onFinish: toggleDeleteProcessModal }))}
          isSubmitting={modalLoading}
          errorMessage={modalError?.message}
        />
      )}

      {categoryModal.isOpen && (
        <CategoryModal
          isOpen={categoryModal.isOpen}
          toggle={toggleCategoryModal}
          mode={categoryModal.mode}
          processType={categoryModal.processType}
          categoryId={categoryModal.categoryId}
        />
      )}

      {categoryModal.isOpenDelete && (
        <ModalDelete
          isOpen={categoryModal.isOpenDelete}
          toggle={toggleDeleteCategoryModal}
          header={I18n.t('chatbot_remove_category')}
          text1={I18n.t('chatbot_remove_category_title')}
          text2={I18n.t('dashboard_action-cannot-reversed')}
          event={() => dispatch(deleteProcessCategory({ categoryId: categoryModal.categoryId, onFinish: toggleDeleteCategoryModal }))}
          isSubmitting={modalLoading}
          errorMessage={modalError?.message}
        />
      )}

      <ModalWrapper
        isOpen={isOpenProcessCalledFromModal}
        toggle={toggleProcessCalledFromModal}
        header={I18n.t('smartchat_process_calledFrom')}
        body={
          <ol className='process-list__called-from-list'>
            {processCalledFrom.map(processId => {
              const process = processesList.find(process => process.processId === processId)
              if (process) {
                return (
                  <li
                    key={processId}
                    className={`
                      process-list__called-process
                      ${process.processType === 'customer_alternative_branch' ? 'process-list__called-process--alternative-branch' : ''}
                    `}
                  >
                    <span>{process.processName}</span>
                  </li>
                )
              }
              return null
            })}
          </ol>
        }
        footer={
          <div className='process-list__called-from-button-modal'>
            <Button
              secondary
              value={I18n.t('dashboard_accept')}
              onClick={toggleProcessCalledFromModal}
            />
          </div>
        }
      />

      <ModalWrapper
        centeredButtons
        isOpen={isOpenProcessNotificationModal}
        toggle={toggleProcessNotificationModal}
        contentClassName='smartchat-modal'
        eventBtnTxt={I18n.t('dashboard_accept')}
        eventBtn={toggleProcessNotificationModal}
        body={
          <div className='modal-content'>
            <p style={{ textAlign: 'center' }}>{modalError && I18n.t(modalError.message)}</p>
          </div>
        }
      />
    </div>
  )
}

export default ProcessesList
